import { NsPrice } from 'components/common/ns-price/NsPrice';

type Props = {
  monthlyAmount?: number;
  annualAmount?: number;
};

export const TariffPrice = ({ monthlyAmount, annualAmount }: Props) => {
  return (
    <>
      <p>
        <span className="h2">
          <NsPrice amount={monthlyAmount} showDecimal />
        </span>
        <span className="p-caption"> / month</span>
      </p>
      <p>
        <span className="p-feature">
          <b>£{annualAmount}</b>
        </span>
        <span className="p-caption"> / year</span>
      </p>
    </>
  );
};
